$(document).ready(function () {
  $('#product-drawings').slick({
    dots: false,
    arrows: true,
    prevArrow: $('.single-product__drawings-prev'),
    nextArrow: $('.single-product__drawings-next'),
  });
});
